import { CountryWithCallingCode, CountryWithPrices, CallingCodeSuggestion } from '../roaming/RoamingInterfaces';
import { Language } from '../stores/LanguageStore';
import { estonianCountryMappings, russianCountryMappings } from './RoamingMappings';

export const FLAG_IMAGE_BASEURL: string = 'https://res.cloudinary.com/telia/image/upload/flags/';

export const mapCountryToNumberSuggestion = (country: CountryWithPrices | CountryWithCallingCode, lang: Language): CallingCodeSuggestion => {
  return {
    id: country.isoCode,
    label: getCountryLabel(country),
    callingCode: country.callingCode,
    synonym: lang === 'et' ? estonianCountryMappings[country.name] : russianCountryMappings[country.name],
    url: '#',
    image: {
      src: `https://res.cloudinary.com/telia/image/upload/flags/${country.isoCode}`,
      role: 'presentation',
    },
  };
};

export const sortCountries = (country1: CountryWithPrices, country2: CountryWithPrices): number => {
  if (country1.name < country2.name) {
    return -1;
  }
  if (country1.name > country2.name) {
    return 1;
  }
  return 0;
};

export const getCountryLabel = (country: CountryWithPrices | CountryWithCallingCode): string => {
  return `${country.name} (+${country.callingCode})`;
};

export const allCountries: CountryWithCallingCode[] = [
  { name: 'Afganistan', isoCode: 'AFG', callingCode: '93' },
  {
    name: 'Albaania',
    isoCode: 'ALB',
    callingCode: '355',
  },
  { name: 'Alžeeria', isoCode: 'DZA', callingCode: '213' },
  { name: 'Ameerika Samoa', isoCode: 'ASM', callingCode: '1' },
  {
    name: 'Ameerika Ühendriigid',
    isoCode: 'USA',
    callingCode: '1',
  },
  { name: 'Andorra', isoCode: 'AND', callingCode: '376' },
  { name: 'Angola', isoCode: 'AGO', callingCode: '244' },
  {
    name: 'Anguilla',
    isoCode: 'AIA',
    callingCode: '1',
  },
  { name: 'Antarktika', isoCode: 'ATA', callingCode: '672' },
  {
    name: 'Antigua ja Barbuda',
    isoCode: 'ATG',
    callingCode: '1',
  },
  { name: 'Araabia Ühendemiraadid', isoCode: 'ARE', callingCode: '971' },
  { name: 'Argentina', isoCode: 'ARG', callingCode: '54' },
  {
    name: 'Armeenia',
    isoCode: 'ARM',
    callingCode: '374',
  },
  { name: 'Aruba', isoCode: 'ABW', callingCode: '297' },
  { name: 'Ascension', isoCode: 'ASC', callingCode: '247' },
  {
    name: 'Aserbaidžaan',
    isoCode: 'AZE',
    callingCode: '994',
  },
  { name: 'Austraalia', isoCode: 'AUS', callingCode: '61' },
  { name: 'Austria', isoCode: 'AUT', callingCode: '43' },
  {
    name: 'Bahama',
    isoCode: 'BHS',
    callingCode: '1',
  },
  { name: 'Bahrein', isoCode: 'BHR', callingCode: '973' },
  { name: 'Bangladesh', isoCode: 'BGD', callingCode: '880' },
  {
    name: 'Barbados',
    isoCode: 'BRB',
    callingCode: '1',
  },
  { name: 'Belgia', isoCode: 'BEL', callingCode: '32' },
  { name: 'Belize', isoCode: 'BLZ', callingCode: '501' },
  {
    name: 'Benin',
    isoCode: 'BEN',
    callingCode: '229',
  },
  { name: 'Bermuda', isoCode: 'BMU', callingCode: '1' },
  { name: 'Bhutan', isoCode: 'BTN', callingCode: '975' },
  {
    name: 'Boliivia',
    isoCode: 'BOL',
    callingCode: '591',
  },
  { name: 'Bosnia ja Hertsegoviina', isoCode: 'BIH', callingCode: '387' },
  { name: 'Botswana', isoCode: 'BWA', callingCode: '267' },
  {
    name: 'Brasiilia',
    isoCode: 'BRA',
    callingCode: '55',
  },
  { name: 'Briti Neitsisaared', isoCode: 'VGB', callingCode: '1' },
  { name: 'Brunei', isoCode: 'BRN', callingCode: '673' },
  {
    name: 'Bulgaaria',
    isoCode: 'BGR',
    callingCode: '359',
  },
  { name: 'Burkina Faso', isoCode: 'BFA', callingCode: '226' },
  { name: 'Burundi', isoCode: 'BDI', callingCode: '257' },
  {
    name: 'Cabo Verde',
    isoCode: 'CPV',
    callingCode: '238',
  },
  { name: 'Colombia', isoCode: 'COL', callingCode: '57' },
  { name: 'Cooki saared', isoCode: 'COK', callingCode: '682' },
  {
    name: 'Costa Rica',
    isoCode: 'CRI',
    callingCode: '506',
  },
  { name: 'Diego Garcia', isoCode: 'DGA', callingCode: '246' },
  { name: 'Djibouti', isoCode: 'DJI', callingCode: '253' },
  {
    name: 'Dominica',
    isoCode: 'DMA',
    callingCode: '1',
  },
  { name: 'Dominikaani Vabariik', isoCode: 'DOM', callingCode: '1' },
  { name: 'Ecuador', isoCode: 'ECU', callingCode: '593' },
  {
    name: 'Eesti',
    isoCode: 'EST',
    callingCode: '372',
  },
  { name: 'Egiptus', isoCode: 'EGY', callingCode: '20' },
  { name: 'Ekvatoriaal-Guinea ', isoCode: 'GNQ', callingCode: '240' },
  {
    name: 'El Salvador',
    isoCode: 'SLV',
    callingCode: '503',
  },
  { name: 'Elevandiluurannik', isoCode: 'CIV', callingCode: '225' },
  { name: 'Eritrea', isoCode: 'ERI', callingCode: '291' },
  {
    name: 'Etioopia',
    isoCode: 'ETH',
    callingCode: '251',
  },
  { name: 'Falklandi saared', isoCode: 'FLK', callingCode: '500' },
  { name: 'Fidži', isoCode: 'FJI', callingCode: '679' },
  {
    name: 'Filipiinid',
    isoCode: 'PHL',
    callingCode: '63',
  },
  { name: 'Fääri saared', isoCode: 'FRO', callingCode: '298' },
  { name: 'Gabon', isoCode: 'GAB', callingCode: '241' },
  {
    name: 'Gambia',
    isoCode: 'GMB',
    callingCode: '220',
  },
  { name: 'Ghana', isoCode: 'GHA', callingCode: '233' },
  { name: 'Gibraltar', isoCode: 'GIB', callingCode: '350' },
  {
    name: 'Grenada',
    isoCode: 'GRD',
    callingCode: '1',
  },
  { name: 'Gruusia', isoCode: 'GEO', callingCode: '995' },
  { name: 'Gröönimaa', isoCode: 'GRL', callingCode: '299' },
  {
    name: 'Guadeloupe',
    isoCode: 'GLP',
    callingCode: '590',
  },
  { name: 'Guam', isoCode: 'GUM', callingCode: '1' },
  { name: 'Guatemala', isoCode: 'GTM', callingCode: '502' },
  {
    name: 'Guinea',
    isoCode: 'GIN',
    callingCode: '224',
  },
  { name: 'Guinea-Bissau', isoCode: 'GNB', callingCode: '245' },
  { name: 'Guyana', isoCode: 'GUY', callingCode: '592' },
  {
    name: 'Haiti',
    isoCode: 'HTI',
    callingCode: '509',
  },
  { name: 'Hiina', isoCode: 'CHN', callingCode: '86' },
  { name: 'Hispaania', isoCode: 'ESP', callingCode: '34' },
  {
    name: 'Holland',
    isoCode: 'NLD',
    callingCode: '31',
  },
  { name: 'Hollandi Antillid', isoCode: 'ANT', callingCode: '599' },
  { name: 'Honduras', isoCode: 'HND', callingCode: '504' },
  {
    name: 'Hongkong',
    isoCode: 'HKG',
    callingCode: '852',
  },
  { name: 'Horvaatia', isoCode: 'HRV', callingCode: '385' },
  { name: 'Ida-Timor', isoCode: 'TLS', callingCode: '670' },
  {
    name: 'Iirimaa',
    isoCode: 'IRL',
    callingCode: '353',
  },
  { name: 'Iisrael', isoCode: 'ISR', callingCode: '972' },
  { name: 'India', isoCode: 'IND', callingCode: '91' },
  {
    name: 'Indoneesia',
    isoCode: 'IDN',
    callingCode: '62',
  },
  { name: 'Iraak', isoCode: 'IRQ', callingCode: '964' },
  { name: 'Iraan', isoCode: 'IRN', callingCode: '98' },
  {
    name: 'Island',
    isoCode: 'ISL',
    callingCode: '354',
  },
  { name: 'Itaalia', isoCode: 'ITA', callingCode: '39' },
  { name: 'Jaapan', isoCode: 'JPN', callingCode: '81' },
  {
    name: 'Jamaica',
    isoCode: 'JAM',
    callingCode: '1',
  },
  { name: 'Jeemen', isoCode: 'YEM', callingCode: '967' },
  { name: 'Jordaania', isoCode: 'JOR', callingCode: '962' },
  {
    name: 'Kaimanisaared',
    isoCode: 'CYM',
    callingCode: '1',
  },
  { name: 'Kambodža', isoCode: 'KHM', callingCode: '855' },
  { name: 'Kamerun', isoCode: 'CMR', callingCode: '237' },
  {
    name: 'Kanada',
    isoCode: 'CAN',
    callingCode: '1',
  },
  { name: 'Kasahstan', isoCode: 'KAZ', callingCode: '7' },
  { name: 'Katar', isoCode: 'QAT', callingCode: '974' },
  {
    name: 'Keenia',
    isoCode: 'KEN',
    callingCode: '254',
  },
  { name: 'Kesk-Aafrika Vabariik', isoCode: 'CAF', callingCode: '236' },
  { name: 'Kiribati', isoCode: 'KIR', callingCode: '686' },
  {
    name: 'Komoorid',
    isoCode: 'COM',
    callingCode: '269',
  },
  { name: 'Kongo', isoCode: 'COG', callingCode: '242' },
  { name: 'Kongo Demokraatlik Vabariik', isoCode: 'COD', callingCode: '243' },
  {
    name: 'Kosovo',
    isoCode: 'MNC',
    callingCode: '383',
  },
  { name: 'Kreeka', isoCode: 'GRC', callingCode: '30' },
  { name: 'Kuuba', isoCode: 'CUB', callingCode: '53' },
  {
    name: 'Kuveit',
    isoCode: 'KWT',
    callingCode: '965',
  },
  { name: 'Kõrgõzstan', isoCode: 'KGZ', callingCode: '996' },
  { name: 'Küpros', isoCode: 'CYP', callingCode: '357' },
  {
    name: 'Laos',
    isoCode: 'LAO',
    callingCode: '856',
  },
  { name: 'Leedu', isoCode: 'LTU', callingCode: '370' },
  { name: 'Lesotho', isoCode: 'LSO', callingCode: '266' },
  {
    name: 'Libeeria',
    isoCode: 'LBR',
    callingCode: '231',
  },
  { name: 'Liechtenstein', isoCode: 'LIE', callingCode: '423' },
  { name: 'Liibanon', isoCode: 'LBN', callingCode: '961' },
  {
    name: 'Liibüa',
    isoCode: 'LBY',
    callingCode: '218',
  },
  { name: 'Luksemburg', isoCode: 'LUX', callingCode: '352' },
  { name: 'Läti', isoCode: 'LVA', callingCode: '371' },
  {
    name: 'Lõuna-Aafrika Vabariik',
    isoCode: 'ZAF',
    callingCode: '27',
  },
  { name: 'Lõuna-Korea', isoCode: 'KOR', callingCode: '82' },
  { name: 'Lõuna-Sudaan', isoCode: 'SSD', callingCode: '211' },
  {
    name: 'Macau',
    isoCode: 'MAC',
    callingCode: '853',
  },
  { name: 'Madagaskar', isoCode: 'MDG', callingCode: '261' },
  { name: 'Makedoonia', isoCode: 'MKD', callingCode: '389' },
  {
    name: 'Malaisia',
    isoCode: 'MYS',
    callingCode: '60',
  },
  { name: 'Malawi', isoCode: 'MWI', callingCode: '265' },
  { name: 'Maldiivid', isoCode: 'MDV', callingCode: '960' },
  {
    name: 'Mali',
    isoCode: 'MLI',
    callingCode: '223',
  },
  { name: 'Malta', isoCode: 'MLT', callingCode: '356' },
  { name: 'Maroko', isoCode: 'MAR', callingCode: '212' },
  {
    name: 'Marshalli saared',
    isoCode: 'MHL',
    callingCode: '692',
  },
  { name: 'Martinique', isoCode: 'MTQ', callingCode: '596' },
  { name: 'Mauritaania', isoCode: 'MRT', callingCode: '222' },
  {
    name: 'Mauritius',
    isoCode: 'MUS',
    callingCode: '230',
  },
  { name: 'Mayotte', isoCode: 'MYT', callingCode: '262' },
  { name: 'Mehhiko', isoCode: 'MEX', callingCode: '52' },
  {
    name: 'Mikroneesia',
    isoCode: 'FSM',
    callingCode: '691',
  },
  { name: 'Moldova', isoCode: 'MDA', callingCode: '373' },
  { name: 'Monaco', isoCode: 'MCO', callingCode: '377' },
  {
    name: 'Mongoolia',
    isoCode: 'MNG',
    callingCode: '976',
  },
  { name: 'Montenegro', isoCode: 'MNE', callingCode: '382' },
  { name: 'Montserrat', isoCode: 'MSR', callingCode: '1' },
  {
    name: 'Mosambiik',
    isoCode: 'MOZ',
    callingCode: '258',
  },
  { name: 'Myanmar', isoCode: 'MMR', callingCode: '95' },
  { name: 'Namiibia', isoCode: 'NAM', callingCode: '264' },
  {
    name: 'Nauru',
    isoCode: 'NRU',
    callingCode: '674',
  },
  { name: 'Neitsisaared', isoCode: 'VIR', callingCode: '1' },
  { name: 'Nepal', isoCode: 'NPL', callingCode: '977' },
  {
    name: 'Nicaragua',
    isoCode: 'NIC',
    callingCode: '505',
  },
  { name: 'Nigeeria', isoCode: 'NGA', callingCode: '234' },
  { name: 'Niger', isoCode: 'NER', callingCode: '227' },
  {
    name: 'Niue',
    isoCode: 'NIU',
    callingCode: '683',
  },
  { name: 'Norra', isoCode: 'NOR', callingCode: '47' },
  { name: 'Omaan', isoCode: 'OMN', callingCode: '968' },
  {
    name: 'Paapua Uus-Guinea',
    isoCode: 'PNG',
    callingCode: '675',
  },
  { name: 'Pakistan', isoCode: 'PAK', callingCode: '92' },
  { name: 'Palau', isoCode: 'PLW', callingCode: '680' },
  {
    name: 'Palestiina',
    isoCode: 'PSE',
    callingCode: '970',
  },
  { name: 'Panama', isoCode: 'PAN', callingCode: '507' },
  { name: 'Paraguay', isoCode: 'PRY', callingCode: '595' },
  {
    name: 'Peruu',
    isoCode: 'PER',
    callingCode: '51',
  },
  { name: 'Poola', isoCode: 'POL', callingCode: '48' },
  { name: 'Portugal', isoCode: 'PRT', callingCode: '351' },
  {
    name: 'Prantsuse Guajaana',
    isoCode: 'GUF',
    callingCode: '594',
  },
  { name: 'Prantsuse Polüneesia', isoCode: 'PYF', callingCode: '689' },
  { name: 'Prantsusmaa', isoCode: 'FRA', callingCode: '33' },
  {
    name: 'Puerto Rico',
    isoCode: 'PRI',
    callingCode: '1',
  },
  { name: 'Põhja Korea', isoCode: 'PRK', callingCode: '850' },
  { name: 'Põhja-Mariaanid', isoCode: 'MNP', callingCode: '1' },
  {
    name: 'Reunion',
    isoCode: 'REU',
    callingCode: '262',
  },
  { name: 'Rootsi', isoCode: 'SWE', callingCode: '46' },
  { name: 'Rumeenia', isoCode: 'ROU', callingCode: '40' },
  {
    name: 'Rwanda',
    isoCode: 'RWA',
    callingCode: '250',
  },
  { name: 'Saalomoni saared', isoCode: 'SLB', callingCode: '677' },
  {
    name: 'Saint Helena',
    isoCode: 'SHN',
    callingCode: '290',
  },
  { name: 'Saint Kitts ja Nevis', isoCode: 'KNA', callingCode: '1' },
  { name: 'Saint Lucia', isoCode: 'LCA', callingCode: '1' },
  {
    name: 'Saint Martin',
    isoCode: 'MAF',
    callingCode: '590',
  },
  { name: 'Saint Pierre and Miquelon', isoCode: 'SPM', callingCode: '508' },
  {
    name: 'Saint Vincent ja Grenadiinid',
    isoCode: 'VCT',
    callingCode: '1',
  },
  { name: 'Saksamaa', isoCode: 'DEU', callingCode: '49' },
  { name: 'Sambia', isoCode: 'ZMB', callingCode: '260' },
  {
    name: 'Samoa',
    isoCode: 'WSM',
    callingCode: '685',
  },
  { name: 'San Marino', isoCode: 'SMR', callingCode: '378' },
  { name: 'Sao Tome and Principe', isoCode: 'STP', callingCode: '239' },
  {
    name: 'Saudi Araabia',
    isoCode: 'SAU',
    callingCode: '966',
  },
  { name: 'Seišellid', isoCode: 'SYC', callingCode: '248' },
  { name: 'Senegal', isoCode: 'SEN', callingCode: '221' },
  {
    name: 'Serbia',
    isoCode: 'SRB',
    callingCode: '381',
  },
  { name: 'Sierra Leone', isoCode: 'SLE', callingCode: '232' },
  { name: 'Singapur', isoCode: 'SGP', callingCode: '65' },
  {
    name: 'Slovakkia',
    isoCode: 'SVK',
    callingCode: '421',
  },
  { name: 'Sloveenia', isoCode: 'SVN', callingCode: '386' },
  { name: 'Somaalia', isoCode: 'SOM', callingCode: '252' },
  {
    name: 'Soome',
    isoCode: 'FIN',
    callingCode: '358',
  },
  { name: 'Sri Lanka', isoCode: 'LKA', callingCode: '94' },
  { name: 'Sudaan', isoCode: 'SDN', callingCode: '249' },
  {
    name: 'Suriname',
    isoCode: 'SUR',
    callingCode: '597',
  },
  { name: 'Suurbritannia', isoCode: 'GBR', callingCode: '44' },
  { name: 'Svaasimaa', isoCode: 'SWZ', callingCode: '268' },
  {
    name: 'Süüria',
    isoCode: 'SYR',
    callingCode: '963',
  },
  { name: 'Taani', isoCode: 'DNK', callingCode: '45' },
  { name: 'Tadžikistan', isoCode: 'TJK', callingCode: '992' },
  {
    name: 'Tai',
    isoCode: 'THA',
    callingCode: '66',
  },
  { name: 'Taiwan', isoCode: 'TWN', callingCode: '886' },
  { name: 'Tansaania', isoCode: 'TZA', callingCode: '255' },
  {
    name: 'Togo',
    isoCode: 'TGO',
    callingCode: '228',
  },
  { name: 'Tokelau', isoCode: 'TKL', callingCode: '690' },
  { name: 'Tonga', isoCode: 'TON', callingCode: '676' },
  {
    name: 'Trinidad ja Tobago',
    isoCode: 'TTO',
    callingCode: '1',
  },
  { name: 'Tuneesia', isoCode: 'TUN', callingCode: '216' },
  { name: 'Turks ja Caicos', isoCode: 'TCA', callingCode: '1' },
  {
    name: 'Tuvalu',
    isoCode: 'TUV',
    callingCode: '688',
  },
  { name: 'Türgi', isoCode: 'TUR', callingCode: '90' },
  { name: 'Türkmenistan', isoCode: 'TKM', callingCode: '993' },
  {
    name: 'Tšaad ',
    isoCode: 'TCD',
    callingCode: '235',
  },
  { name: 'Tšehhi', isoCode: 'CZE', callingCode: '420' },
  { name: 'Tšiili', isoCode: 'CHL', callingCode: '56' },
  {
    name: 'Uganda',
    isoCode: 'UGA',
    callingCode: '256',
  },
  { name: 'Ukraina', isoCode: 'UKR', callingCode: '380' },
  { name: 'Ungari', isoCode: 'HUN', callingCode: '36' },
  {
    name: 'Uruguay',
    isoCode: 'URY',
    callingCode: '598',
  },
  { name: 'Usbekistan', isoCode: 'UZB', callingCode: '998' },
  { name: 'Uus-Kaledoonia', isoCode: 'NCL', callingCode: '687' },
  {
    name: 'Uus-Meremaa',
    isoCode: 'NZL',
    callingCode: '64',
  },
  { name: 'Valgevene', isoCode: 'BLR', callingCode: '375' },
  { name: 'Vanuatu', isoCode: 'VUT', callingCode: '678' },
  {
    name: 'Venemaa',
    isoCode: 'RUS',
    callingCode: '7',
  },
  { name: 'Venezuela', isoCode: 'VEN', callingCode: '58' },
  { name: 'Vietnam', isoCode: 'VNM', callingCode: '84' },
  {
    name: 'Wallis and Futuna',
    isoCode: 'WLF',
    callingCode: '681',
  },
  { name: 'Zimbabwe', isoCode: 'ZWE', callingCode: '263' },
  { name: 'Šveits', isoCode: 'CHE', callingCode: '41' },
];
